"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockPcbLayoutGroupNode = exports.mockPcbLayoutTextNode = exports.mockPcbLayoutElementNode = exports.mockPcbLayoutNetNode = exports.mockPcbRouteSegmentNode = exports.mockPcbLayoutModelNode = exports.mockPcbLayoutLayoutNode = exports.mockPcbLayoutViaNode = exports.mockPcbLayoutPadNode = void 0;
exports.createMockRootFootprintNode = createMockRootFootprintNode;
exports.mockPcbLayoutFootprintNode = mockPcbLayoutFootprintNode;
exports.createMockRootLayoutNode = createMockRootLayoutNode;
exports.createMockLayoutNode = createMockLayoutNode;
exports.createMockComponentsNode = createMockComponentsNode;
exports.createMockNetsNode = createMockNetsNode;
exports.createMockPcbPadNodeMap = createMockPcbPadNodeMap;
exports.createMockPcbLayoutNodes = createMockPcbLayoutNodes;
const shared_1 = require("@buildwithflux/shared");
const structure_1 = require("../../src/pcb/bakedRule/structure");
const structure_2 = require("../../src/pcb/node/structure");
const helpers_1 = require("../helpers");
const mockPcbRuleData_1 = require("./mockPcbRuleData");
const mockPcbLayoutPadNode = (overrides) => {
    return {
        uid: helpers_1.chance.guid(),
        name: helpers_1.chance.animal(),
        type: structure_2.PcbNodeTypes.pad,
        parentUid: helpers_1.chance.guid(),
        pcbNodeRuleSet: {
            position: (0, mockPcbRuleData_1.mockPositionPcbLayoutRule)(),
            rotation: (0, mockPcbRuleData_1.mockRotationPcbLayoutRule)(),
        },
        childUids: [],
        ...overrides,
    };
};
exports.mockPcbLayoutPadNode = mockPcbLayoutPadNode;
const mockPcbLayoutViaNode = (overrides) => {
    return {
        uid: helpers_1.chance.guid(),
        name: helpers_1.chance.animal(),
        type: structure_2.PcbNodeTypes.via,
        parentUid: helpers_1.chance.guid(),
        pcbNodeRuleSet: {
            position: (0, mockPcbRuleData_1.mockPositionPcbLayoutRule)(),
            rotation: (0, mockPcbRuleData_1.mockRotationPcbLayoutRule)(),
        },
        childUids: [],
        ...overrides,
    };
};
exports.mockPcbLayoutViaNode = mockPcbLayoutViaNode;
const mockPcbLayoutLayoutNode = (overrides) => {
    return {
        uid: helpers_1.chance.guid(),
        name: helpers_1.chance.animal(),
        type: structure_2.PcbNodeTypes.layout,
        parentUid: helpers_1.chance.guid(),
        pcbNodeRuleSet: {
            position: (0, mockPcbRuleData_1.mockPositionPcbLayoutRule)(),
            rotation: (0, mockPcbRuleData_1.mockRotationPcbLayoutRule)(),
        },
        childUids: [],
        ...overrides,
    };
};
exports.mockPcbLayoutLayoutNode = mockPcbLayoutLayoutNode;
const mockPcbLayoutModelNode = (overrides) => {
    return {
        uid: helpers_1.chance.guid(),
        name: helpers_1.chance.animal(),
        type: structure_2.PcbNodeTypes.model,
        parentUid: helpers_1.chance.guid(),
        pcbNodeRuleSet: {
            position: (0, mockPcbRuleData_1.mockPositionPcbLayoutRule)(),
            rotation: (0, mockPcbRuleData_1.mockRotationPcbLayoutRule)(),
        },
        childUids: [],
        ...overrides,
    };
};
exports.mockPcbLayoutModelNode = mockPcbLayoutModelNode;
const mockPcbRouteSegmentNode = (overrides) => {
    return {
        uid: helpers_1.chance.guid(),
        name: helpers_1.chance.animal(),
        type: structure_2.PcbNodeTypes.routeSegment,
        parentUid: helpers_1.chance.guid(),
        pcbNodeRuleSet: {
            position: (0, mockPcbRuleData_1.mockPositionPcbLayoutRule)(),
            rotation: (0, mockPcbRuleData_1.mockRotationPcbLayoutRule)(),
        },
        startId: "",
        endId: "",
        childUids: [],
        ...overrides,
    };
};
exports.mockPcbRouteSegmentNode = mockPcbRouteSegmentNode;
const mockPcbLayoutNetNode = (overrides) => {
    return {
        uid: helpers_1.chance.guid(),
        name: helpers_1.chance.animal(),
        parentUid: helpers_1.chance.guid(),
        type: structure_2.PcbNodeTypes.net,
        pcbNodeRuleSet: {
            position: (0, mockPcbRuleData_1.mockPositionPcbLayoutRule)(),
            rotation: (0, mockPcbRuleData_1.mockRotationPcbLayoutRule)(),
        },
        terminals: {},
        childUids: [],
        ...overrides,
    };
};
exports.mockPcbLayoutNetNode = mockPcbLayoutNetNode;
const mockPcbLayoutElementNode = (overrides) => {
    return {
        uid: helpers_1.chance.guid(),
        name: helpers_1.chance.animal(),
        type: structure_2.PcbNodeTypes.element,
        parentUid: helpers_1.chance.guid(),
        pcbNodeRuleSet: {
            position: (0, mockPcbRuleData_1.mockPositionPcbLayoutRule)(),
            rotation: (0, mockPcbRuleData_1.mockRotationPcbLayoutRule)(),
        },
        childUids: [],
        ...overrides,
    };
};
exports.mockPcbLayoutElementNode = mockPcbLayoutElementNode;
const mockPcbLayoutTextNode = (overrides) => {
    return {
        uid: helpers_1.chance.guid(),
        name: helpers_1.chance.animal(),
        type: structure_2.PcbNodeTypes.text,
        parentUid: helpers_1.chance.guid(),
        pcbNodeRuleSet: {
            position: (0, mockPcbRuleData_1.mockPositionPcbLayoutRule)(),
            rotation: (0, mockPcbRuleData_1.mockRotationPcbLayoutRule)(),
        },
        childUids: [],
        ...overrides,
    };
};
exports.mockPcbLayoutTextNode = mockPcbLayoutTextNode;
function createMockRootFootprintNode(overrides) {
    return mockPcbLayoutFootprintNode({
        type: structure_2.PcbNodeTypes.footprint,
        parentUid: structure_2.pcbLayoutRootNodeId,
        ...overrides,
    });
}
function mockPcbLayoutFootprintNode(overrides) {
    return {
        uid: helpers_1.chance.guid(),
        name: helpers_1.chance.animal(),
        type: structure_2.PcbNodeTypes.footprint,
        parentUid: helpers_1.chance.guid(),
        pcbNodeRuleSet: {},
        childUids: [],
        ...overrides,
    };
}
function createMockRootLayoutNode(overrides) {
    return createMockLayoutNode({
        parentUid: structure_2.pcbLayoutRootNodeId,
        childUids: [],
        ...overrides,
    });
}
function createMockLayoutNode(overrides) {
    return {
        uid: helpers_1.chance.guid(),
        name: helpers_1.chance.animal(),
        type: structure_2.PcbNodeTypes.layout,
        parentUid: helpers_1.chance.guid(),
        pcbNodeRuleSet: {},
        childUids: [],
        ...overrides,
    };
}
function createMockComponentsNode(overrides) {
    return {
        uid: helpers_1.chance.guid(),
        name: "Components",
        type: structure_2.PcbNodeTypes.container,
        parentUid: helpers_1.chance.guid(),
        pcbNodeRuleSet: {},
        childUids: [],
        ...overrides,
    };
}
function createMockNetsNode(overrides) {
    return {
        uid: helpers_1.chance.guid(),
        name: "Nets",
        type: structure_2.PcbNodeTypes.container,
        parentUid: helpers_1.chance.guid(),
        pcbNodeRuleSet: {},
        childUids: [],
        ...overrides,
    };
}
function createMockPcbPadNodeMap(schematicTerminals, overrides) {
    const result = {};
    // eslint-disable-next-line @buildwithflux/no-array-foreach
    Object.values(schematicTerminals).forEach((terminal) => {
        const pcbPadNode = createMockPcbPadNodeFromSchematicTerminal(terminal, overrides);
        result[pcbPadNode.uid] = pcbPadNode;
    });
    return result;
}
function createMockPcbPadNodeFromSchematicTerminal(schematicTerminal, overrides) {
    return {
        uid: helpers_1.chance.guid(),
        name: helpers_1.chance.animal(),
        type: structure_2.PcbNodeTypes.pad,
        parentUid: "footprint-one",
        terminalId: schematicTerminal.name,
        pcbNodeRuleSet: {
            position: (0, mockPcbRuleData_1.mockPositionPcbLayoutRule)(),
            rotation: (0, mockPcbRuleData_1.mockRotationPcbLayoutRule)(),
            size: (0, mockPcbRuleData_1.mockSizePcbLayoutRule)(),
            padShape: (0, mockPcbRuleData_1.mockPcbLayoutRule)({
                uid: "padShape",
                key: "padShape",
                value: (0, shared_1.getRandomArrayItem)(Object.values(structure_1.PcbLayoutFootprintPadShape)),
            }),
            padHoleType: (0, mockPcbRuleData_1.mockPcbLayoutRule)({
                uid: "padHoleType",
                key: "padHoleType",
                value: (0, shared_1.getRandomArrayItem)(Object.values(structure_1.FootPrintPadHoleType)),
            }),
            cornerRadius: (0, mockPcbRuleData_1.mockPcbLayoutRule)({
                uid: "padHoleType",
                key: "padHoleType",
                value: helpers_1.chance.integer(),
            }),
        },
        childUids: [],
        ...overrides,
    };
}
function createMockPcbLayoutNodes(amount, parentUid) {
    const result = {};
    for (let i = 0; i < amount; i++) {
        const newMockPcbLayoutNode = (0, exports.mockPcbLayoutPadNode)(parentUid ? { parentUid: parentUid } : undefined);
        result[newMockPcbLayoutNode.uid] = newMockPcbLayoutNode;
    }
    return result;
}
const mockPcbLayoutGroupNode = (overrides) => {
    return {
        uid: helpers_1.chance.guid(),
        name: helpers_1.chance.animal(),
        type: structure_2.PcbNodeTypes.group,
        parentUid: helpers_1.chance.guid(),
        pcbNodeRuleSet: {},
        childUids: [],
        ...overrides,
    };
};
exports.mockPcbLayoutGroupNode = mockPcbLayoutGroupNode;
//# sourceMappingURL=mockPcbNodeData.js.map